import { render, staticRenderFns } from "./CashAccountBalance.vue?vue&type=template&id=ddb08354&scoped=true"
import script from "./CashAccountBalance.vue?vue&type=script&lang=ts"
export * from "./CashAccountBalance.vue?vue&type=script&lang=ts"
import style0 from "./CashAccountBalance.vue?vue&type=style&index=0&id=ddb08354&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb08354",
  null
  
)

export default component.exports